import { GetSidebarItemFn } from "@/components/layout/Sidebar/sidebar.types";
import { fmsAdvisorSidebarItems } from "@/features/views/sidebar-items/sidebar-items-fmsAdvisor";
import { serviceManagerSidebarItems } from "@/features/views/sidebar-items/sidebar-items-serviceManager";
import { teamLeadSidebarItems } from "@/features/views/sidebar-items/sidebar-items-teamLead";
import { technicianSidebarItems } from "@/features/views/sidebar-items/sidebar-items-technician";
import type { View } from "@/features/views/view-definitions";

export const sidebarViewMap: Record<View, GetSidebarItemFn[]> = {
    fmsAdvisor: fmsAdvisorSidebarItems,
    technician: technicianSidebarItems,
    teamLead: teamLeadSidebarItems,
    serviceManager: serviceManagerSidebarItems,
};
